<template>
	<div class="member-wrapper">
		<div class="member-head">
			<span class="label">群成员</span>
			<span class="btn-text" @click="invite">添加</span>
		</div>
		<div class="member-body">
			<div class="user-dl"
				v-for="(item,index) in groupinfoList.members"
				:key="index"
				@click="select(item)"
			>
				<div class="user-dt">
					<img v-if="item.PhotoUrl" :src="item.PhotoUrl" alt="" class="avatar">
					<img v-else src="@/assets/avatar.png" alt="" class="avatar">
				</div>
				<div class="user-dd">
					<span class="nickname">{{item.DisplayName || item.member || item.owner}}</span>
					<!-- <groupUserSetting :item="item"  v-show="!item.owner&&(adminList.includes(username) || groupinfoList.admin == username)&&username != item.member" /> -->
				</div>
			</div>
		</div>
		<el-dialog class="invite-dialog" :visible.sync="showInvite" :modal="false">
			<div class="invite">
				<h3 class="title">邀请群成员</h3>
				<img class="qrcode" :src="qrcode" alt="">
				<p class="tips">请截图转发好友，扫码进群。该二维码24小时内有效，若失效请重新邀请。</p>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import QRCode from 'qrcode';
// import GetGroupSetting from "./groupSetting.vue";
// import GroupUserSetting from "./groupUserSetting.vue";
export default{
	components: {
		// GetGroupSetting,
		// GroupUserSetting
	},
	data(){
		return {
			select_id: "",
			select_name: "",
			// 控制群组详情页
			showGroupInfoModel: false,
			// 控制详情页图标
			showInfoIcon: false,
			// 控制setAdmin图标
			// showAdminIcon: false,
			// 控制setMute 图标
			// showMuteIcon: false,

			setAdminIcon: "设为管理员",
			removeAdminIcon: "移除管理员",
			setMute: "禁言",
			removeMute: "移除禁言",
			setBlack: "加入群黑名单",
			setRemove: "从本群移除",
			qrcode:'',
			showInvite:false,
		};
	},
	computed: {
		groupinfoList(){
			return this.$store.state.group.groupInfo;
		},
		username(){
			return this.$store.state.hxLoginId; // 
		},
		adminList(){
			return this.$store.state.group.adminList;
		},
		muteList(){
			return this.$store.state.group.muteList;
		},
		hxIsLogin(){
			return this.$store.state.hxIsLogin;
		}
	},
	watch: {
		hxIsLogin(value){
			if(value){
				this.chengeInfoModel();
			}
		}
	},
	mounted() {
		if(this.hxIsLogin){
			this.chengeInfoModel();
		}
	},
	methods: {
		...mapActions([
			"onGetGroupinfo",
			"onSetAdmin",
			"onRemoveAdmin",
			"getGroupAdmin",
			"getMuted",
			"onAddMute",
			"onRemoveMute",
			"onAddGroupBlack",
			"onRemoveGroupUser"
		]),
		closeGroupSet(){
			this.chengeInfoModel()
			this.$emit("closeGroupMessage");
		},
		chengeInfoModel(){
			this.$data.showGroupInfoModel = !this.$data.showGroupInfoModel;
			if(this.$data.showSettingModel){
				this.chengeSetModel();
			}
			let chatId=this.$store.state.chatId;
			setTimeout(()=>{
				this.getGroupAdmin({ select_id: chatId });
				if(this.adminList.includes(this.username) || this.groupinfoList.admin == this.username){
					this.getMuted({ select_id: chatId });
				}
			}, 100);
		},
		chengeSetModel(){
			this.$refs.groupSettingModel.changeSettingModel();
		},
		// chengeAdminIcon() {
		//   this.$data.showAdminIcon = !this.$data.showAdminIcon;
		// },
		// chengeMuteIcon() {
		//   this.$data.showMuteIcon = !this.$data.showMuteIcon;
		// },

		select(key){
			this.$data.select_name = key.member;
		},
		openSetAdmin(){
			const me = this;
			this.$confirm("确认操作: 设为管理员", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onSetAdmin({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name,
					success: function(){
						me.getGroupAdmin({ select_id: me.$store.state.group.groupInfo.gid });
						me.$forceUpdate();
					}
				});
				this.chengeAdminIcon();
				this.$message({
					type: "success",
					message: "设置管理员成功"
				});
			})
		},
		openRemoveAdmin(){
			const me = this;
			this.$confirm("确认操作: 移除管理员", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onRemoveAdmin({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name,
					success: function(){
						me.getGroupAdmin({ select_id: me.$store.state.group.groupInfo.gid });
						me.$forceUpdate();
					}
				});
				this.chengeAdminIcon();
				this.$message({
					type: "success",
					message: "移除管理员成功"
				});
			})
		},
		openSetMute(){
			const me = this;
			this.$confirm("确认操作: 禁言", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onAddMute({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name,
					success: function(){
						me.getMuted({ select_id: me.$store.state.group.groupInfo.gid });
						me.$forceUpdate();
					}
				});
				// this.chengeMuteIcon();
				this.$message({
					type: "success",
					message: "禁言成功"
				});
			})
		},
		openRemoveMute(){
			const me = this;
			this.$confirm("确认操作: 移除禁言", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onRemoveMute({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name,
					success: function(){
						me.getMuted({ select_id: me.$store.state.group.groupInfo.gid });
						me.$forceUpdate();
					}
				});
				// this.chengeMuteIcon();
				this.$message({
					type: "success",
					message: "移除禁言列表成功"
				});
			})
		},
		openGroupBlack(){
			this.$confirm("确认操作: 加入群黑名单", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onAddGroupBlack({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name
				});
				this.$message({
					type: "success",
					message: "加入群黑名单成功"
				});
			})
		},
		openRemoveGroupUser(){
			this.$confirm("确认操作: 从本群移除", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
			.then(() => {
				this.onRemoveGroupUser({
					select_id: this.$store.state.group.groupInfo.gid,
					select_name: this.$data.select_name
				});
				this.$message({
					type: "success",
					message: "移除成员成功"
				});
			})
		},
    invite(){
        this.showInvite=true;
      var opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1,
        color: {
          dark:"#000000",
          light:"#ffffff"
        }
      }
      var that=this;
      let inviter='';
      for (let i = 0; i < this.groupinfoList.members.length; i++) {
        if(this.$store.state.hxLoginId== this.groupinfoList.members[i].EasemobUserName){
          inviter=this.groupinfoList.members[i].DisplayName;
        }
			}
			// 设置参数方式
			
			let PLATFORM = process.env.VUE_APP_MODE;
			let origin= '';
			switch (PLATFORM) {
				case 'development':
					// origin=window.location.protocol+"//wx.gongkongbpo.qa"
					origin=window.location.protocol+"//wx.qa.gongkongbpo.com"
					break;
				case 'test':
					origin=window.location.protocol+"//twx.insupai.com"
					break;
				default:
					origin=window.location.protocol+"//wx.insupai.com"
					break;
			}
			let path=`${origin}/#/inviteMember?groupId=${this.groupinfoList.gid}&time=${new Date().getTime()}&inviter=${encodeURIComponent(inviter)}&groupName=${this.groupinfoList.name}&members=${this.groupinfoList.members.length}`;
			QRCode.toDataURL( path, opts, function (err, url) {
        if (err) throw err
        that.qrcode=url;
			})
    }
	},
};
</script>
<style scoped lang="scss">
@import "./group.scss";
.invite-dialog{
	.invite{
		width: 300px;
		margin: 0 auto;
		text-align: center;
	}
	.title{
		font-size: 18px;
		font-weight: bold;
		color: #333;
		text-align: center;
		margin-bottom: 20px;
	}
	.qrcode{
		width: 200px;
		height: 200px;
		margin-bottom: 20px;
		border: 1px solid #ccc;
		padding: 10px;
	}
	.tips{
		font-size: 12px;
		color: #999;
		line-height: 22px;
	}
}
.member-wrapper{
	position: relative;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.member-head{
	overflow: hidden;
	padding: 5px 10px;
	.label{
		font-size: 14px;
		color: #333;
		font-weight: bold;
		line-height: 30px;
		float: left;
	}
	.btn-text{
		font-size: 14px;
		color: #f75959;
		line-height: 30px;
		float: right;
		cursor: pointer;
		user-select: none;
	}
}

.member-body{
	width: 100%;
	height: 100px;
	flex:1;
	overflow-y: auto;
	.user-dl{
		overflow: hidden;
		padding: 5px 10px;
		position: relative;
		display: flex;
	}
	.user-dt{
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}
	.avatar{
		width: 100%;
		height: 100%;
		border-radius: 50%;
		display: block;
	}
	.user-dd{
		width: 154px;
		flex: 1;
		font-size: 14px;
		color: #333;
		height: 36px;
		line-height: 36px;
	}
	.nickname{
		display: inline-block;
		width: 160px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.admin{
		font-size: 12px;
		color: #f75959;
		margin-left: 10px;
	}
}
.info-modal {
  padding: 0 10px;
  height: 100%;
  /* width: 350px !important; */
  /* cursor: pointer; */
}
.setting-icon {
  position: absolute;
  right: 30px;
}
.info-icon {
  position: absolute;
  right: 30px;
  cursor: pointer;
  overflow: hidden;
}
.info-name ::selection {
  width: 40px;
  background: #00ba6e;
}
.info-setting {
  list-style-type: none;
  text-align: left;
  padding-left: 0;
  /* position: absolute;
  right: 30px; */
}
.info-user {
  overflow-y: auto;
}
.listItem{
  height: 50px;
  border-bottom: 1px solid #ccc;
  line-height: 50px;
  color: #666;
  font-size: 14px;
}
.groupName{
  color: #666;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}
.memberBox{
  margin-top: 20px;
  height: calc(100% - 100px);
  overflow-y: scroll;
  position: relative;
}

</style>
